import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  variant?: 'default' | 'row' | 'current';
  tone?: 'plain' | 'success' | 'warning';
  className?: string;
}

export function Card({ children, variant = 'default', tone = 'plain', className }: CardProps) {
  const variantClass = variant === 'row' ? ' card--row' : variant === 'current' ? ' card--current' : '';
  const toneClass = tone === 'success' ? ' card--success' : tone === 'warning' ? ' card--warning' : '';
  return <div className={`card${variantClass}${toneClass}${className ? ` ${className}` : ''}`}>{children}</div>;
}

interface StatCardProps {
  value: string;
  label: string;
  tone?: 'default' | 'mint' | 'terracotta';
}

export function StatCard({ value, label, tone = 'default' }: StatCardProps) {
  const toneClass =
    tone === 'mint' ? ' stat__value--mint' : tone === 'terracotta' ? ' stat__value--terracotta' : '';
  return (
    <div className="card">
      <div className={`stat__value${toneClass}`}>{value}</div>
      <div className="stat__label">{label}</div>
    </div>
  );
}
